<!-- eslint-disable -->
<template>
  <loading v-model:active="isLoading" :is-full-page="fullPage" />
  <div id="main" class="layout-horizontal">
    <PrimaryTopBar />
    <div class="content-wrapper container">
      <div class="page-heading" v-show="!showRinci">
        <h3><router-link :to="{path: '/dashboard'}" class="icon-back"><i class="bi bi-chevron-left"></i></router-link> Riwayat Pembayaran BPP</h3>
      </div>

      <div class="page-content" v-show="!showRinci">
        <section class="row">
          <div class="col-12 col-lg-8">
            <div class="card">
              <div class="card-content">
                <div class="card-body">
                    <h4 class="card-title fs-5 mb-3">Informasi Riwayat Pembayaran BPP 6 Bulan Terakhir</h4>
                    <ul class="list-group list-group-flush">
                      <li class="list-group-item list-group-item-action d-flex justify-content-between"  v-for="row in dataPembayaran" :key="row.id" @click.prevent="getRincian(row.id)">
                        <small>Tanggal Pembayaran<br><strong class="label-info">{{ row.tgl_setoran }}</strong></small>
                        <small>{{ row.nama_bank }}<br><strong class="label-info">Rp. {{ $filters.currencyUSD(row.jumlah) }}</strong></small>
                      </li>
                    </ul>
                </div>
                
              </div>
            </div>
          </div>
        </section>
      </div>

      <div class="page-heading"  v-show="showRinci">
        <h3><a @click.prevent="offRincianSetoran()" class="icon-back"><i class="bi bi-chevron-left"></i></a> Rincian Riwayat Pembayaran</h3>
      </div>
      <RincianSetoran v-bind:postRincian="dataRincian" v-bind:jumlahTotal="jumlahSetoran" v-show="showRinci"/>

    </div>
    
  </div>
</template>
<!-- eslint-disable -->
<script>
import axios from "axios";
import PrimaryTopBar from "@/components/layout/PrimaryTopBar.vue";
import RincianSetoran from "@/components/RincianSetoran.vue";
import Loading from 'vue-loading-overlay';

export default {
  name: "Dashboard",
  components: {
    PrimaryTopBar,
    RincianSetoran,
    Loading
  },
  data() {
    return {
      biodata: [],
      apiKey : '',
      formSetoran : [],
      formRincian : [],
      dataPembayaran : [],
      dataRincian : [],
      jumlahSetoran : '0',
      isLoading: false,
      fullPage: true,
      showRinci:false,
    };
  },
  mounted() {
    this.loadPage();
  },
  methods: {
    async loadPage() {
      this.isLoading = true;
      if(localStorage.getItem('setusers')){
        this.biodata = JSON.parse(localStorage.getItem('setusers'));
        this.apiKey  = localStorage.getItem('token');
      }

      this.getPembayaran();
      setTimeout(() => {
        this.isLoading = false;
      }, 1000);
    },
    async getPembayaran() {
      this.isLoading = true;
      this.formSetoran = { nis:this.biodata.nis, key:this.apiKey };
      await axios.post('/api/public/riwayatpayment',JSON.stringify(this.formSetoran)).then(response => {
          let data = response.data;
          if(data.code === '200') {
            this.dataPembayaran = data.records;
          }
      });
    },
    async getRincian(id) {
      this.isLoading = true;
      this.formRincian = { nis:this.biodata.nis, key:this.apiKey,id_payment : id };
      await axios.post('/api/public/riwayatrinci',JSON.stringify(this.formRincian)).then(response => {
          let data = response.data;
          if(data.code === '200') {
            this.dataRincian = data.records;
            this.jumlahSetoran = data.jumlah;
          }
          
          setTimeout(() => {
            this.isLoading = false;
            this.showRinci = true;
          }, 200);
      });
    },
    async offRincianSetoran () { 
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
        this.showRinci = false;
      }, 200);
    }
  }
}
</script>